// extracted by mini-css-extract-plugin
module.exports = {"button":"smallButton_button__2iEAQ","icon":"smallButton_icon__3BXA4","active":"smallButton_active__2vimn","small":"smallButton_small__3oIk3"};